export default "/images/f5983c18f44422e121db3415608d4087.avif";